import { FormPage } from "./FormPage";

class FormNavigation {
    public formPages: FormPage[];
    private selectedPage: FormPage;

    constructor(formPages: FormPage[], selectedPageId: string) {
        this.formPages = formPages;
        this.setSelectedPageById(selectedPageId);
    }

    public setSelectedPageById(pageId: string): FormPage {
        this.selectedPage = this.formPages.firstOrDefault(p => p.id === pageId) ?? this.selectedPage;
        return this.selectedPage;
    }

    public getSelectedPage(): FormPage {
        return this.selectedPage;
    }

    public isFirstPageSelected(): boolean {
        return this.formPages.indexOf(this.selectedPage) === 0;
    }

    public isLastPageSelected(): boolean {
        return this.formPages.indexOf(this.selectedPage) === this.formPages.length - 1;
    }

    public isSelectedPage(formPage: FormPage): boolean {
        return this.selectedPage.id === formPage.id;
    }

    public nextPage(): FormPage {
        if (!this.isLastPageSelected())
            this.selectedPage = this.formPages[this.getSelectedPageIndex() + 1];

        return this.selectedPage;
    }

    public previousPage(): FormPage {
        if (!this.isFirstPageSelected())
            this.selectedPage = this.formPages[this.getSelectedPageIndex() - 1];

        return this.selectedPage;
    }

    private getSelectedPageIndex(): number {
        return this.formPages.indexOf(this.selectedPage);
    }
}

export { FormNavigation };
